module.exports = __webpack_public_path__ + "bin/42a2a68901cc8392e33d5bd651828142.jpg";